import React, { useState } from "react";
import TextField from "./TextField.js";

export const PEEK_VALUES = [ "toggle", "none", "hold" ];

export default function PasswordField(props) {
    const [isVisible, setVisible] = useState(false);

    let { peek } = props;
    if (PEEK_VALUES.indexOf(peek) < 0) peek = PEEK_VALUES[0];

    let onClick = () => {};
    let onMouseDown = () => {};
    let onMouseUp = () => {};
    let title = "";
    let cursor = "initial";
    let icon = undefined;

    if (peek === "toggle") {
        onClick = () => setVisible(! isVisible);
        title = isVisible ? "hide password" : "show password";
        cursor = "pointer"
        icon = isVisible ? "visibility_off" : "visibility";
    }
    if (peek === "hold") {
        onMouseDown = () => setVisible(true)
        onMouseUp = () => setVisible(false)
        title = "hold to peek"
        cursor = "pointer"
        icon = isVisible ? "visibility_off" : "visibility";
    }

    return <TextField {...props}
        renderIcon={icon => (
            <span title={title}
                style={{ cursor, color: props.iconColor || "var(--yona-color-50)" }}
                className="material-icons yona-textField-icon" 
                onClick={onClick}
                onMouseDown={onMouseDown}
                onMouseUp={onMouseUp}
                onTouchStart={onMouseDown}
                onTouchEnd={onMouseUp}
            >{icon}</span>
        )}
        type={isVisible ? "text" : "password"}
        icon={icon}
    />;
};